import { useState } from "react";
import { HouseDoorFill, TelephoneFill } from "styled-icons/bootstrap";
import { BuildingBank, Mail } from "styled-icons/fluentui-system-filled";
import MessageSend from "./MessageSend";

const Contact = () => {
  const [showAlert, setShowAlert] = useState(false);

  return (
    <>
      <div className="mt-3 flex flex-col items-center gap-6">
        <ul className="flex flex-col items-center gap-2 text-xl">
          <li>
            <a href="mailto:beratung.klotz.brenner@gmx.net" className="flex justify-between gap-3">
              <Mail className="w-6" />
              beratung.klotz.brenner@gmx.net
            </a>
          </li>
          <li>
            <a href="tel:+4915151936485" className="flex justify-between gap-3">
              <TelephoneFill className="w-6" />
              +49 151 51936485
            </a>
          </li>
          <li>
            <a
              href="https://goo.gl/maps/KpSyFvVN3ainqKon8"
              target="_blank"
              rel="noreferrer"
              className="flex justify-between gap-3"
            >
              <HouseDoorFill className="w-6" />
              Hafnerweg 1, 89231 Neu-Ulm
            </a>
          </li>
          <li>
            <span className="flex justify-between gap-3">
              <BuildingBank className="w-6" />
              DE88 1203 0000 1204 5467 80
            </span>
          </li>
        </ul>
        <div className="">
          <p>
            Eine Gesprächseinheit dauert in der Regel 90 Minuten bei einem Honorar von 90&nbsp;€ für ein Einzelgespräch
            und 110&nbsp;€ für ein Paargespräch. Für Auszubildende und Studenten gibt es eine Ermäßigung.
          </p>
        </div>
      </div>
      {showAlert && <MessageSend close={() => setShowAlert(false)} />}
    </>
  );
};

export default Contact;
